/**
 * Suhaani Weaves — product recommendations.
 *
 * Shopify's recommendations are only available through a dedicated endpoint,
 * so the section renders empty on first paint and fills itself here. If there
 * are no recommendations the container stays empty and CSS hides it, rather
 * than the page showing an empty heading.
 */
(function () {
  'use strict';

  const container = document.querySelector('[data-related]');
  if (!container) return;

  const productId = container.getAttribute('data-product-id');
  const limit = container.getAttribute('data-limit') || '4';
  const base = container.getAttribute('data-url');
  if (!productId || !base) return;

  /* Already rendered server-side (a cached recommendations response). */
  if (container.querySelector('.product-grid')) return;

  const url =
    base + '?section_id=related-products&product_id=' + productId + '&limit=' + limit;

  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error('Recommendations unavailable');
      return response.text();
    })
    .then((markup) => {
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const next = parsed.querySelector('[data-related]');
      if (next && next.innerHTML.trim()) container.innerHTML = next.innerHTML;
    })
    .catch(() => {
      /* Leave the section empty; it is an enhancement, not part of the purchase path. */
    });
})();
